import Component from '@bythepixel/component-loader';
import cookieIsSet from '@Core/utility/cookieIsSet';

export default class AlertBanner extends Component {
  static selector = '[data-comp-banner]';

  constructor(containerEl) {
    super(containerEl);
    this.closeButton = this.$container.querySelector('[data-close-button]');
    this.cookieName = 'closeTopBanner';

    if (!cookieIsSet(this.cookieName)) {
      this.$container.classList.remove('hidden');
    }

    this.addCloseButtonListener();
  }

  addCloseButtonListener() {
    this.closeButton.addEventListener('click', () => {
      this.setCookie();
      this.$container.classList.add('hidden');
    });
  }

  setCookie() {
    const expirationDate = new Date();

    // Cookie is set to expire in 24 hours
    expirationDate.setDate(expirationDate.getDate() + 1);

    document.cookie = `${this.cookieName}=set; expires=${expirationDate}; path=/`;
  }
}
